// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oJXGVny7vh09oj9k5_c1{grid-template-columns:max-content 1fr max-content;justify-content:right;align-items:center;gap:8px;width:100%;height:32px;padding-left:8px;padding-right:8px;display:grid}.oJXGVny7vh09oj9k5_c1.mFs0buwue_0DFuDCzDkJ{grid-template-columns:1fr max-content;gap:0}.oJXGVny7vh09oj9k5_c1.hPvhgj9KKYgHvuMO5juf,.oJXGVny7vh09oj9k5_c1.mFs0buwue_0DFuDCzDkJ{background:var(--background-neutral-default);border-radius:4px}.oJXGVny7vh09oj9k5_c1.ZktRrHesB10qKZXOg6Af{height:40px}.vNZEGvSqcmIbCYhzwamT{margin-left:-4px;margin-right:-4px}.knRgDYYLu2wSp5xy8jJp{font-feature-settings:"tnum";margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"player": `oJXGVny7vh09oj9k5_c1`,
	"recordAudio": `mFs0buwue_0DFuDCzDkJ`,
	"visible": `hPvhgj9KKYgHvuMO5juf`,
	"large": `ZktRrHesB10qKZXOg6Af`,
	"playBtn": `vNZEGvSqcmIbCYhzwamT`,
	"time": `knRgDYYLu2wSp5xy8jJp`
};
export default ___CSS_LOADER_EXPORT___;
